/* Paintlab header — vanilla, no jQuery, bound to no Ella selector. */
(function () {
  'use strict';

  var nav    = document.querySelector('.plh-nav');
  var links  = nav ? [].slice.call(nav.querySelectorAll('.plh-nav-link')) : [];
  var panels = nav ? [].slice.call(nav.querySelectorAll('.plh-panel')) : [];
  var openTimer, closeTimer;

  function setOpen(id) {
    links.forEach(function (a) {
      a.setAttribute('aria-expanded', a.getAttribute('data-dept') === id ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      p.setAttribute('data-open', p.getAttribute('data-panel') === id ? 'true' : 'false');
    });
  }
  function closeAll() { setOpen(null); }

  links.forEach(function (a) {
    var id = a.getAttribute('data-dept');
    a.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer); clearTimeout(openTimer);
      openTimer = setTimeout(function () { setOpen(id); }, 110);
    });
    a.addEventListener('focus', function () { clearTimeout(closeTimer); setOpen(id); });
  });

  if (nav) {
    nav.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    nav.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeAll, 200);
    });
  }

  document.addEventListener('focusin', function (e) {
    if (nav && !nav.contains(e.target)) closeAll();
  });

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('.plh-drawer');
  var scrim  = document.querySelector('.plh-scrim');
  var panes  = drawer ? [].slice.call(drawer.querySelectorAll('.plh-pane')) : [];

  function showPane(name) {
    panes.forEach(function (p) {
      p.setAttribute('data-active', p.getAttribute('data-pane') === name ? 'true' : 'false');
    });
    var body = drawer && drawer.querySelector('.plh-drawer-body');
    if (body) body.scrollTop = 0;
  }
  function openDrawer() {
    if (!drawer) return;
    showPane('root');
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (t.closest('[data-plh-open]'))  { e.preventDefault(); openDrawer();  return; }
    if (t.closest('[data-plh-close]')) { e.preventDefault(); closeDrawer(); return; }
    var drill = t.closest('[data-open-pane]');
    if (drill) { e.preventDefault(); showPane(drill.getAttribute('data-open-pane')); return; }
    if (t.closest('[data-back]')) { e.preventDefault(); showPane('root'); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) { closeAll(); closeDrawer(); }
  });

  /* Ella's jquery.sticky path is retired in favour of CSS position:sticky. */
  window.fixtop_menu = false;
})();
